import styled from 'styled-components';
import { canvas, text, body, breakpoint, spacing } from '@carvana/ds-styles';

const BottomContent = styled.div`
  margin-top: ${spacing.xl};
`;
const Container = styled.div`
  min-width: 300px;
  margin-right: 16px;
  align-items: flex-start;
  box-sizing: border-box;
  background-color: ${canvas.default};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  height: 244px;
  padding: 24px;

  @media screen and (min-width: ${breakpoint.sm}) {
    min-width: 344px;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    min-width: 304px;
  }

  @media screen and (min-width: ${breakpoint.lg}) {
    min-width: 389px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    min-width: 413px;
  }

  &.expanded {
    height: auto;
  }
`;

const StarsContainer = styled.div`
  margin-bottom: 16px;
`;

const ReviewText = styled.p`
  color: ${text.default};
  margin-bottom: 8px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  ${body.regular.sm};

  @media screen and (min-width: ${breakpoint.md}) {
    -webkit-line-clamp: 4;
  }

  &.expanded {
    display: block;
    margin-bottom: 16px;
  }
`;

const CustomerDetails = styled.div`
  display: flex;
  justify-self: flex-end;
  align-items: baseline;
  color: ${text.default};
  ${body.regular.sm};
`;

const CustomerName = styled.span`
  color: ${text.strong};
  ${body.strong.sm};
`;

const Date = styled.div`
  color: ${text.default};
  ${body.regular.sm}
`;

export {
  BottomContent,
  Container,
  StarsContainer,
  ReviewText,
  CustomerDetails,
  CustomerName,
  Date
};
